import Button from 'components/partials/button/button';

const GoalContactItem = (): React.JSX.Element => {
  const handleEmailClick = (): void => {
    window.location.href = 'mailto:clientsupport@marketviewedu.com';
  };

  return (
    <div className="w-full bg-navy-800 py-8 px-4 text-white rounded-md flex flex-col items-center mt-10">
      <h2 className="text-xl font-bold mb-2">Are your goals missing?</h2>
      <p className="mb-4 text-navy-100">
        Contact your Client Success Team to discuss your priorities and ensure
        your goals are fully aligned and up to date.
      </p>
      <Button variant="brand-filled" size="sm" onClick={handleEmailClick}>
        Speak to Us
      </Button>
    </div>
  );
};

export default GoalContactItem;
